<form [formGroup]="organizationSpecificDataForm">
  <markant-input
    *ngIf="organizationSpecificDataForm.controls['masterKin'] as masterKin"
    class="registration-form-input"
    id="masterKin"
    data-cy="input-masterKin"
    name="masterKin"
    [maxlength]="8"
    [formControlName]="'masterKin'"
    [showLabelHint]="true"
    [label]="'register.organization.masterKin' | transloco"
    [placeholder]="'22211100'"
    [helper]="'organization.details.fields.masterKin.hint' | transloco"
    [helperCharacterCounter]="true"
    [error]="
      masterKin.errors
        | formControlError: showError || masterKin.touched || masterKin.dirty
    "
    [errorText]="
      masterKin.errors
        | formControlKeyError
          : 'organization.details.fields.masterKin.validation'
          : showError || masterKin.touched || masterKin.dirty
        | transloco
    "
    [required]="masterKin.hasValidator(Validators.required)"
  >
  </markant-input>

  <ng-container formArrayName="furtherKins">
    <div class="registration-form-array">
      <span>
        {{ 'register.organization.furtherKins' | transloco }}
      </span>

      <markant-icon-button
        colorScheme="dark"
        icon="m_plus"
        (click)="addFurtherKin()"
      ></markant-icon-button>
    </div>

    <ng-container
      *ngFor="let furtherKin of furtherKins.controls; let i = index"
    >
      <div [formGroupName]="i">
        <markant-input
          *ngIf="furtherKin.get('kin') as kinControl"
          required
          class="registration-form-input"
          id="'further-kin-'{{ i }}"
          name="'further-kin-name-'{{ i }}"
          [maxlength]="8"
          [showLabelHint]="true"
          [helperCharacterCounter]="true"
          [placeholder]="'22211100'"
          [label]="
            ('organization.details.fields.furtherKins.label' | transloco) +
            ' - ' +
            (i + 1)
          "
          [helper]="'organization.details.fields.masterKin.hint' | transloco"
          [formControlName]="'kin'"
          [error]="
            kinControl.errors
              | formControlError
                : showError || kinControl.touched || kinControl.dirty
          "
          [errorText]="
            kinControl.errors
              | formControlKeyError
                : 'organization.details.fields.furtherKins.validation'
                : showError || kinControl.touched || kinControl.dirty
              | transloco
          "
        >
          <markant-icon
            slot="markant-input-icon-trailing"
            icon="m_minus"
            [style.cursor]="'pointer'"
            [clickable]="true"
            (click)="removeFurtherKin(i)"
          ></markant-icon>
        </markant-input>
      </div>
    </ng-container>
  </ng-container>

  <markant-input
    *ngIf="organizationSpecificDataForm.controls['crmId'] as crmId"
    class="registration-form-input"
    id="crmId"
    data-cy="input-crm-id"
    name="crmId"
    [showLabelHint]="true"
    [label]="'register.organization.crmId' | transloco"
    [formControlName]="'crmId'"
    [error]="
      crmId.errors | formControlError: showError || crmId.touched || crmId.dirty
    "
    [errorText]="
      crmId.errors
        | formControlKeyError
          : 'organization.details.fields.crmId.validation'
          : showError || crmId.touched || crmId.dirty
        | transloco
    "
  >
  </markant-input>
</form>
